exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CanvasPage___1bMJ5 {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n", ""]);

// exports
exports.locals = {
	"CanvasPage": "CanvasPage___1bMJ5"
};